export function resolveInitialTargetOrganisationId({ organisationId, availableOrganisations, currentTargetOrganisationId }) {
    const availableIds = (availableOrganisations || []).map(({ organisationId: orgId }) => orgId);

    if (availableIds.includes(currentTargetOrganisationId)) return currentTargetOrganisationId;
    if (availableIds.includes(organisationId)) return organisationId;
    return availableIds[0];
}

export function shouldDisableCreateOrder({ organisationsLoading, organisationsError, targetOrganisationId }) {
    return organisationsLoading || !!organisationsError || !targetOrganisationId;
}
